import { Component, OnInit } from '@angular/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ArchiveJobService } from '../../../services/archive-job.service';
import { ArchiveJob, ArchiveJobIdTitle } from '../../../models/archive-job.model';
import { BulkDocAddPayload } from '../../../models/review/bulk-doc-add-payload.model';
import { SelectionService } from '../../../models/review/selection-service';
import { OkCancelDialogComponent } from '../../dialogs/ok-cancel/ok-cancel-dialog.component';

@Component({
    selector: 'lex-archive-job',
    templateUrl: './archive-job.component.html',
    styleUrls: ['./archive-job.component.scss'],
    standalone: false
})
export class ArchiveJobComponent implements OnInit {
  archiveJobs: ArchiveJobIdTitle[] = new Array<ArchiveJob>();

  constructor(private archiveJobService: ArchiveJobService, public selectionService: SelectionService, private dialog: MatDialog) { }

  ngOnInit() {
    this.archiveJobService.getArchiveJobsStatusPreRun()
      .subscribe(data => {
        this.archiveJobs = data;
      });
  }

  addDocs(change: MatSelectChange) {
    this.selectionService.operationAlert = null;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: `Add Docs To: ${change.value.title}`,
      message: `Total Docs Selected: ${this.selectionService.SelectedCount}`
    };
    dialogConfig.panelClass = 'add-docs-to-job-panel';

    this.dialog.open(OkCancelDialogComponent, dialogConfig).afterClosed().subscribe((okClicked: boolean) => {
      if (okClicked) {
        const payload: BulkDocAddPayload = this.createBulkPayload();
        this.archiveJobService.addDocsToArchiveJob(change.value.archiveJobId, payload)
          .subscribe(data => this.handleDocsAdded(data));
      }
      const matSelect: MatSelect = change.source;
      matSelect.writeValue(null);
    });
  }

  createBulkPayload(): BulkDocAddPayload {
    const payload: BulkDocAddPayload = new BulkDocAddPayload();
    payload.docIds = this.selectionService.selection.selected.map(s => s.docId);
    payload.selectAll = this.selectionService.selectAllFlag;
    payload.filterId = this.selectionService.getSavedFilterId();
    return payload;
  }

  handleDocsAdded(success: boolean) {
    let feedback = '';
    if (success === true)
      feedback = 'Documents added';
    else if (success === false)
      feedback = 'Documents have already been added';
    else
      feedback = 'There was an error';

    this.selectionService.operationAlert = feedback;
  }
}
